import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'No tengo horno profesional',
  a: 'Por eso incluimos 2 guías completas de postres sin horno para que empieces a facturar hoy mismo. No necesitas equipo industrial para crear postres premium.'
}, {
  q: 'No sé usar Instagram',
  a: "El Ebook 'Instagram Paso a Paso' te lleva de la mano, aunque nunca hayas publicado nada. Aprenderás a tomar fotos con tu celular y a escribir textos que venden."
}, {
  q: '¿El acceso es inmediato?',
  a: 'Sí, recibes los 8 PDFs en tu correo un segundo después de la compra. Podrás descargarlos en tu celular, tablet o computadora y leerlos cuando quieras.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-cream" data-id="element-16">
      <div className="max-w-3xl mx-auto" data-id="element-17">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-chocolate mb-12" data-id="element-18">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-19">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl border border-chocolate/10 overflow-hidden shadow-sm" data-id="element-20">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-21">
                <span className="font-bold text-lg text-chocolate pr-4" data-id="element-22">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-23" />
              </button>

              <AnimatePresence data-id="element-24">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-25">
                    <div className="px-6 pb-5 text-chocolate-light leading-relaxed" data-id="element-26">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}